import * as Yup from 'yup';

import { FormPage } from 'components/page';
import { CondicaoPagamentoFormMain } from 'pages/complementar/condicao-pagamento/components';
import { useMutateCondicaoPagamento } from 'pages/complementar/condicao-pagamento/hooks';

export function CondicaoPagamentoFormComp() {
    const { handleSubmit } = useMutateCondicaoPagamento();

    const validationSchema = Yup.object({
        dsCondicaoPagamento: Yup.string().min(2).max(200).required(),
        cdCondicaoPagamento: Yup.string().required(),
        nrParcela: Yup.number().required(),
        meioPagamento: Yup.object().required(),
        gatewayPagamento: Yup.object().required(),
    });

    return (
        <FormPage
            fgAtivo
            goBackButton
            title="Condição de Pagamento"
            url="/gestao/condicaopagamento/"
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
            validateOnSubmit={true}
            validateOnChange={false}
            values={{}}
        >
            <CondicaoPagamentoFormMain />
        </FormPage>
    );
}
